// Liste di ruoli dei permessi campo (show / edit / edit_empty_only).
//
// '*' vuol dire "tutti i ruoli" e il backend lo considera tale solo quando e'
// l'unico elemento della lista. Nel select compare come voce "Tutti i ruoli",
// cosi' quello che si vede coincide con quello che viene applicato: con
// l'esclusione accesa "Tutti i ruoli" nasconde il campo a tutti, ed e' scritto.
// '*' e i singoli ruoli si escludono a vicenda: scegliendo un ruolo '*' sparisce,
// riscegliendo "Tutti i ruoli" spariscono i singoli ruoli. Le liste miste gia'
// salvate (tipo ['*', 7, 8]) valgono "solo 7 e 8" e vengono ripulite.
//
// Togliendo tutti i ruoli la lista resterebbe vuota, che senza esclusione per il
// backend vale "nessun ruolo": su show ed edit il campo sparirebbe a tutti,
// Admin compreso. In quel caso la lista torna ['*']. Con l'esclusione accesa la
// lista vuota e' giusta ("nessuno escluso") e resta vuota. Per questo la
// normalizzazione guarda anche il flag *_exclude e va rifatta quando cambia
// l'interruttore, non solo la lista.
// edit_empty_only non e' toccata sul vuoto: li' la lista vuota e' il default e
// vuol dire "nessuna restrizione".
const VUOTA_VALE_TUTTI = ['show', 'edit']

export default {

	methods: {
		// Etichetta del select che dice cosa vuol dire la lista con l'interruttore
		// di esclusione nella posizione attuale
		rolePermissionLabel(key, permissions) {
			const escludi = !!(permissions && permissions[key + '_exclude'])
			const etichette = {
				show: escludi ? 'Ruoli che NON vedono il campo' : 'Solo questi ruoli vedono il campo',
				edit: escludi ? 'Ruoli che NON possono modificare il campo' : 'Solo questi ruoli possono modificare il campo',
				edit_empty_only: escludi ? 'Tutti tranne questi ruoli modificano solo se vuoto' : 'Questi ruoli modificano solo se vuoto',
			}

			return etichette[key]
		},

		// Voci del select dei ruoli, con "Tutti i ruoli" in testa
		roleItemsWithAll(roles) {
			return [{text: 'Tutti i ruoli', value: '*'}, ...(roles || [])]
		},

		normalizeRoles(roles) {
			if (!Array.isArray(roles) || roles.length <= 1) {
				return roles
			}

			// Il select accoda l'ultima voce scelta: se e' "Tutti i ruoli",
			// sostituisce i singoli ruoli invece di sparire
			if (roles[roles.length - 1] === '*') {
				return ['*']
			}

			return roles.filter(role => role !== '*')
		},

		normalizeRolePermissions(permissions) {
			if (!permissions) {
				return permissions
			}

			const normalized = {...permissions}

			for (const key of ['show', 'edit', 'edit_empty_only']) {
				if (!(key in normalized)) {
					continue
				}

				let ruoli = this.normalizeRoles(normalized[key])

				if (VUOTA_VALE_TUTTI.includes(key) && Array.isArray(ruoli) && ruoli.length === 0 && !normalized[key + '_exclude']) {
					ruoli = ['*']
				}

				normalized[key] = ruoli
			}

			return normalized
		},

		// Da chiamare al cambio di una lista di ruoli o di un interruttore di
		// esclusione: v-model ha gia' aggiornato il valore quando arriva @change
		applyRolePermissions(field) {
			field.permissions = this.normalizeRolePermissions(field.permissions)
		}
	}
}
